export const data = {
  currentPage: 0,
};
